import {ChangeDetectionStrategy, Component, contentChild, TemplateRef} from '@angular/core';
import {ToastNoAnimation} from 'ngx-toastr';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[ms-toast-wrapper]',
  templateUrl: './toast-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class ToastWrapperComponent extends ToastNoAnimation {
  readonly template = contentChild<TemplateRef<unknown>>(TemplateRef);

  readonly actions = {
    remove: () => this.remove(),
  };
}
